import React, { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform, useScroll } from "framer-motion";
import { youtube } from "../data/content";

const badges = [
  { label: "20+ Products Shipped", top: "6%", left: "-10%" },
  { label: `${youtube.subs} Subscribers`, top: "44%", right: "-14%" },
  { label: "6+ Years Experience", bottom: "10%", left: "-6%" },
];

const maskGradient =
  "linear-gradient(180deg, transparent 0%, black 10%, black 74%, transparent 99%)";

export default function HeroPortrait() {
  const wrapRef = useRef(null);

  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rotateX = useSpring(useTransform(my, [-60, 60], [10, -10]), { stiffness: 120, damping: 16 });
  const rotateY = useSpring(useTransform(mx, [-60, 60], [-10, 10]), { stiffness: 120, damping: 16 });
  const floatX = useSpring(useTransform(mx, [-60, 60], [-12, 12]), { stiffness: 80, damping: 18 });

  const { scrollYProgress } = useScroll({ target: wrapRef, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.92, 1, 0.86]);
  const wrapOpacity = useTransform(scrollYProgress, [0, 0.15, 0.75, 1], [0.3, 1, 1, 0.15]);
  const glowScale = useTransform(scrollYProgress, [0, 0.5, 1], [0.8, 1.15, 0.8]);

  const handleMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    mx.set(e.clientX - rect.left - rect.width / 2);
    my.set(e.clientY - rect.top - rect.height / 2);
  };
  const handleLeave = () => {
    mx.set(0);
    my.set(0);
  };

  return (
    <div ref={wrapRef} style={{ position: "relative" }}>
      <motion.div style={{ scale, opacity: wrapOpacity }} onMouseMove={handleMove} onMouseLeave={handleLeave}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
          style={{ position: "relative", width: "min(420px, 78vw)", margin: "0 auto", perspective: 1000 }}
        >
          {/* pulsing gradient glow behind the subject */}
          <motion.div
            style={{
              scale: glowScale,
              position: "absolute",
              inset: "6%",
              borderRadius: "50%",
              background:
                "radial-gradient(circle at 45% 35%, rgba(0,229,255,0.55), rgba(168,85,247,0.4) 45%, transparent 72%)",
              filter: "blur(38px)",
              zIndex: 0,
            }}
            animate={{ opacity: [0.7, 1, 0.7] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          />

          {/* thin rotating rim ring for a HUD feel */}
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 22, repeat: Infinity, ease: "linear" }}
            style={{
              position: "absolute",
              inset: "2%",
              borderRadius: "50%",
              border: "1px dashed rgba(0,229,255,0.35)",
              zIndex: 0,
            }}
          />

          <motion.div
            style={{
              rotateX,
              rotateY,
              x: floatX,
              transformStyle: "preserve-3d",
              position: "relative",
              zIndex: 1,
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/gaurav-hero.png`}
              alt="Portrait of Gaurav Bhadauria, founder of Engineer Codewala"
              style={{
                width: "100%",
                display: "block",
                filter: "drop-shadow(0 30px 60px rgba(0,0,0,0.55)) drop-shadow(0 0 40px rgba(0,229,255,0.18))",
                WebkitMaskImage: maskGradient,
                maskImage: maskGradient,
              }}
            />
          </motion.div>

          {badges.map((b, i) => (
            <motion.div
              key={b.label}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1, y: [0, -8, 0] }}
              transition={{
                opacity: { delay: 1.1 + i * 0.15, duration: 0.5 },
                scale: { delay: 1.1 + i * 0.15, duration: 0.5 },
                y: { delay: 1.6 + i * 0.3, duration: 3.4 + i * 0.4, repeat: Infinity, ease: "easeInOut" },
              }}
              style={{
                position: "absolute",
                top: b.top,
                bottom: b.bottom,
                left: b.left,
                right: b.right,
                zIndex: 2,
                padding: "8px 14px",
                borderRadius: 999,
                background: "rgba(10,10,18,0.65)",
                backdropFilter: "blur(12px)",
                border: "1px solid var(--border-strong)",
                fontFamily: "var(--font-mono)",
                fontSize: 11,
                letterSpacing: "0.03em",
                color: "var(--text)",
                whiteSpace: "nowrap",
                boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
              }}
            >
              {b.label}
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </div>
  );
}
